import Image from 'next/future/image';
import cn from 'classnames';
import { getContrastYIQ } from '@/lib/collections/helpers';
import checkmark from '@/public/icons/product/checkmark.svg';
import checkmarkBlack from '@/public/icons/product/checkmarkBlack.svg';

const ColorSwatch = (props: {
  color: string | undefined;
  active: boolean;
  outOfStock: boolean;
  suggested?: boolean | undefined;
}) =>
  props.color == null ? null : (
    <div
      className={cn(
        'flex h-full w-full items-center justify-center rounded-full sm:top-3.5 ',
        { 'w-[45px]': props.suggested },
        { 'ring-2 ring-gray-700 ring-offset-2': props.active },
        {
          'ring-1 ring-gray-700 ring-offset-2':
            !props.active && !props.suggested,
        },
      )}
      // eslint-disable-next-line react/forbid-dom-props
      style={{ backgroundColor: props.color }}
    >
      {props.active && (
        // eslint-disable-next-line tailwindcss/enforces-negative-arbitrary-values
        <span className="-mt-[1px] w-[15px] items-center xs:w-[12px]">
          <Image
            src={
              getContrastYIQ(props.color.replace('#', '')) === 'white'
                ? checkmark
                : checkmarkBlack
            }
            alt={props.color}
            className="w-full"
          />
        </span>
      )}
      {/* OOS disabled */}
      {props.outOfStock && (
        <span
          className={cn(
            'absolute h-[80%] w-[2px] rotate-45 xs:h-full xs:w-[1px] ',
            {
              'bg-white':
                getContrastYIQ(props.color.replace('#', '')) === 'white',
              'bg-gray-700':
                getContrastYIQ(props.color.replace('#', '')) !== 'white',
            },
          )}
        ></span>
      )}
    </div>
  );

export default ColorSwatch;
